import SsciAddStudentPage from "./SsciAddStudentPage";

export default SsciAddStudentPage